@if (isLoading) {
  <div class="w-full h-screen flex justify-center items-center">
    <app-lottie-plane name="load" class="w-[350px] h-[350px]" />
  </div>
} @else {
  <div class="flex flex-col min-h-screen">
    <app-header class="top-0" />
    @if (!isError) {
      <main class="flex-1 w-full min-w-max pt-[60px] bg-background-500">
        @if (!isInactive) {
          @if (isParams) {
            <div class="my-6">
              <app-stepers [listSteps]="listSteps" />
            </div>
          }
          <router-outlet />
        } @else {
          <app-inactive-message (buttonClick)="onClickInactive()" />
        }
      </main>
      @if (!(loadingState.isOverlayActive$ | async)) {
        <app-footer class="w-full min-w-max" />
      }
    } @else {
      <app-error-message
        [detail]="errorState.errorDetail$ | async"
        (buttonClickPrimary)="onClickErrorPrimary()"
        (buttonClickSecondary)="onClickErrorSecondary()" />
    }
  </div>
}
